<template>
    <div class="container" style="padding-top: 12px;">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
        </div>
        <el-table :data="dataTree" style="width: 100%;" row-key="sysPermissionId" border default-expand-all
            :tree-props="{ children: 'children' }">
            <el-table-column prop="sysPermissionName" label="权限名称"></el-table-column>
            <el-table-column prop="sysPermissionUrl" label="权限地址"></el-table-column>
            <el-table-column prop="sysPermissionIcon" label="权限图标">
                <template slot-scope="scope">
                    <i :class="scope.row.sysPermissionIcon"></i>
                </template>
            </el-table-column>
            <el-table-column prop="sysPermissionSort" label="权限序号"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.sysPermissionStatus == 1 ? 'success' : 'danger'">{{ scope.row.sysPermissionStatus == 1 ? "启用" : "禁用" }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="功能按钮" width="400">
                <template slot-scope="scope">
                    <div v-if="scope.row.sysPermissionButtonNameList">
                        <el-tag v-for="button in scope.row.sysPermissionButtonNameList.split(',')" style="margin-right: 12px;">{{ button }}</el-tag>
                    </div>
                    <div v-else>-</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="handleClick('button', scope.row)" type="text" size="small">按钮</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="80px">
                    <el-form-item label="父级权限">
                        <el-select v-model="handleInfo.sysPermissionParent" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in parentList" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="权限名称">
                        <el-input v-model="handleInfo.sysPermissionName"></el-input>
                    </el-form-item>
                    <el-form-item label="权限URL">
                        <el-input v-model="handleInfo.sysPermissionUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="权限状态">
                        <el-select v-model="handleInfo.sysPermissionStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="权限图标">
                        <el-input v-model="handleInfo.sysPermissionIcon"></el-input>
                    </el-form-item>
                    <el-form-item label="权限序号">
                        <el-input v-model="handleInfo.sysPermissionSort"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <div v-if="handle == 'button'">
                <el-tag :key="tag" v-for="button in buttons" closable :disable-transitions="false" @close="buttonDelete(button.sysPermissionButtonId)" style="margin-right: 12px;">{{ button.sysPermissionButtonName }}</el-tag>
                <div style="display: flex; align-items: center; margin-top: 25px;">
                    <div style="flex-shrink: 0; font-size: 16px;">新增功能按钮：</div>
                    <el-input style="margin: 0px 12px 0px 6px;" v-model="buttonName"></el-input>
                    <el-button @click="buttonAdd" type="primary">新增功能按钮</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet, doPost, doDelete } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            buttonId: "",
            permissionId: "",
            buttons: [],
            buttonName: "",
            parentList: [{
                name: "无",
                value: "0"
            }],
            dataTree: [],
            treeProps: {
                label: "sysPermissionName",
                value: "sysPermissionId",
                children: "children"
            }
        }
    },
    methods: {
        getButtons: async function() {
            this.buttons = await doGet("/sysPermissionButton" + API.ALL, {
                "sys_permission_id": this.permissionId
            });
            this.buttonName = "";
        },
        buttonAdd: async function() {
            if (this.buttonName == "") {
                this.$message.error("请输入功能按钮名称！");
                return;
            }
            let resultObj = await doPost("/sysPermissionButton", {
                "sysPermissionId": this.permissionId,
                "sysPermissionButtonName": this.buttonName
            });
            if (resultObj.errorCode == 0) {
                this.$message.success("功能按钮添加成功！");
                this.getButtons();
            } else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        buttonDelete: async function(id) {
            this.buttonId = id;
            this.$confirm(`是否确认要删除当前操作按钮？删除后数据无法恢复`, "删除提示", {
                confirmButtonText: "确认删除",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async (res) => {
                let resultObj = await doDelete("/sysPermissionButton", this.buttonId);
                if (resultObj.errorCode == 0) {
                    this.$message.success("功能按钮删除成功！");
                    this.getButtons();
                } else {
                    this.$message.error(resultObj.errorMessage);
                }
            }).catch(() => { });
        },
        getData: async function () {
            this.parentList = [{
                name: "无",
                value: "0"
            }];
            let arr = await doGet(API.PERMISSION + API.ALL, {
                sys_permission_parent: "0"
            });
            if (arr != null) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].sysPermissionParent == "0") {
                        this.parentList.push({
                            name: arr[i].sysPermissionName,
                            value: arr[i].sysPermissionId
                        });
                    }
                }
            }
            this.dataTree = await doGet(API.TREE.PERMISSION);
        },
        beforeHandleOpenEx: async function (handle, info, customer) {
            this.permissionId = info.sysPermissionId;
            if (handle == "button") {
                this.getButtons();
            }
        }
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>